const SECTION_TYPE_NORMALIZATION = {
  'cart': 'shopping-cart',
  'team-members': 'team',
  'teammembers': 'team',
  'shopping-cart': 'shopping-cart',
  'shoppingcart': 'shopping-cart',
  'image-gallery-modal': 'image-gallery-modal',
  'imagegallerymodal': 'image-gallery-modal',
  'points-table': 'points-table',
  'pointstable': 'points-table',
  'section-items': 'section-items',
  'sectionitems': 'section-items',
  'left-sidebar': 'left-sidebar',
  'leftsidebar': 'left-sidebar',
  'right-sidebar': 'right-sidebar',
  'rightsidebar': 'right-sidebar',
  'audio': 'audio'
}

function normalizeSectionType(sectionType) {
  const key = (sectionType || '').toString().trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-')
  return SECTION_TYPE_NORMALIZATION[key] || key
}

export function isFormStylingApplied(sectionFormStyling, sectionType, sectionId) {
  if (!sectionFormStyling) return false

  const normalizedSectionType = normalizeSectionType(sectionType)
  const selectedSectionTypes = Array.isArray(sectionFormStyling.selectedSectionTypes) ? sectionFormStyling.selectedSectionTypes : []
  const selectedFormSectionTypes = Array.isArray(sectionFormStyling.selectedFormSectionTypes) && sectionFormStyling.selectedFormSectionTypes.length > 0
    ? sectionFormStyling.selectedFormSectionTypes
    : selectedSectionTypes
  const selectedIds = Array.isArray(sectionFormStyling.selectedFormSectionIds) ? sectionFormStyling.selectedFormSectionIds : []

  const selectedTypes = selectedFormSectionTypes.map(normalizeSectionType)
  const matchesByType = selectedTypes.includes(normalizedSectionType)
  const matchesById = sectionId && selectedIds.includes(sectionId)

  if (selectedIds.length > 0 && selectedTypes.length > 0) {
    return matchesByType || matchesById
  }

  if (selectedIds.length > 0) {
    return matchesById
  }

  return matchesByType
}

export function isButtonStylingApplied(sectionFormStyling, sectionType, sectionId) {
  if (!sectionFormStyling) return false

  const normalizedSectionType = normalizeSectionType(sectionType)
  const selectedSectionTypes = Array.isArray(sectionFormStyling.selectedSectionTypes) ? sectionFormStyling.selectedSectionTypes : []
  const selectedButtonSectionTypes = Array.isArray(sectionFormStyling.selectedButtonSectionTypes) && sectionFormStyling.selectedButtonSectionTypes.length > 0
    ? sectionFormStyling.selectedButtonSectionTypes
    : selectedSectionTypes
  const selectedIds = Array.isArray(sectionFormStyling.selectedButtonSectionIds) ? sectionFormStyling.selectedButtonSectionIds : []

  const selectedTypes = selectedButtonSectionTypes.map(normalizeSectionType)
  const matchesByType = selectedTypes.includes(normalizedSectionType)
  const matchesById = sectionId && selectedIds.includes(sectionId)

  if (selectedIds.length > 0 && selectedTypes.length > 0) {
    return matchesByType || matchesById
  }

  if (selectedIds.length > 0) {
    return matchesById
  }

  return matchesByType
}
